import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const tinybirdApi = createApi({
  reducerPath: "tinybirdApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${import.meta.env.VITE_API_BASE_URL}`,
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    // send events to backend for tracking
    postEvent: builder.mutation<void, any>({
      query: (body) => ({
        url: "tinybird/visits/",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { usePostEventMutation } = tinybirdApi;
